
import SettingTransportation from "components/ManageTransportaition";
import FooterTransportation from "components/ManageTransportaition/FooterTransportation";
import ProductLayout from "layouts/ProductLayout";

function ManageTransportationPage() {

  return (
    <ProductLayout namePage="จัดการขนส่ง" footerComponent={<FooterTransportation />}  >
      <div className="layout-content">
        <SettingTransportation />
      </div>
    </ProductLayout>
  );
}

export default ManageTransportationPage;